
import image01 from "../../assets/crushImages/1.jpg"
import image02 from "../../assets/crushImages/2.jpg"
import image03 from "../../assets/crushImages/3.jpg"
import image04 from "../../assets/crushImages/4.jpg"
import image05 from "../../assets/crushImages/5.jpg"
import image06 from "../../assets/crushImages/6.jpg"
import image07 from "../../assets/crushImages/7.jpg"
import image08 from "../../assets/crushImages/8.jpg"
import image09 from "../../assets/crushImages/9.jpg"
import image10 from "../../assets/crushImages/10.jpg"
import image11 from "../../assets/crushImages/11.jpg"
import image12 from "../../assets/crushImages/12.jpg"
import image13 from "../../assets/crushImages/13.jpg"
import image14 from "../../assets/crushImages/14.jpg"
import image15 from "../../assets/crushImages/15.jpg"
import image16 from "../../assets/crushImages/16.jpg"
import image17 from "../../assets/crushImages/17.jpg"
import image18 from "../../assets/crushImages/18.jpg"
import image19 from "../../assets/crushImages/19.jpg"
import image20 from "../../assets/crushImages/20.jpg"
  
export default  [
        {id : 1 , src: image01 , desc: " Life isn’t perfect. But my saree draping can be."},
        {id : 2 , src: image02 , desc: "The waves of the sea help me get back to me."},
        {id : 3 , src: image03 , desc: "Every woman has a bit of red in her personality. We just gotta bring it out."},
        {id : 4 , src: image04 , desc: "Shinrin-Yoku"},
        {id : 5 , src: image05 , desc: "There are no beautiful surfaces without a terrible depth"},
        {id : 6 , src: image06 , desc: "These old monuments are the reflection of our history."},
        {id : 7 , src: image07 , desc: "To be natural is such a very difficult pose to keep up."},
        {id : 8 , src: image08 , desc: "It is not how much we have, but how much we enjoy, that makes happiness."},
        {id : 9 , src: image09 , desc: "Love is in the air."},
        {id : 10 , src: image10 , desc: "Cofee, contour and confidence."},
        {id : 11 , src: image11 , desc: "No sight is more provocative of awe than is the night sky."},
        {id : 12 , src: image12 , desc: "Every time I see you I fall in love all over again."},
        {id : 13 , src: image13 , desc: "A mind that is stretched by a new experience can never go back to its old dimensions."},
        {id : 14 , src: image14 , desc: "Weakness of attitude becomes weakness of character."},
        {id : 15 , src: image15 , desc: "Nature is beyond human existing much before the existence of human."},
        {id : 16 , src: image16 , desc: "There is no sunrise so beautiful that it is worth waking me up to see it."},
        {id : 17 , src: image17 , desc: "You have lovely, deep eyes. Does the world look any better to you?"},
        {id : 18 , src: image18 , desc: "Whoever said that no one is perfect has never seen you."},
        {id : 19 , src: image19 , desc: "She is Rainbow in black."},
        {id : 20 , src: image20 , desc: "You’re so beautiful that you made me forget my pick up line."},

    ]